import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { FloatInput } from '../../../../Common/Class/FloatLabelInput';
import { showToast ,handleError} from '../../../../Common/fToast/ToastCallback';
import { TitleTopHeader,Title as Header } from '../../../../Header/TopHeader';
import { pluginsGetApi,pluginsPostApis } from '../../../../../Model/Network/Config/Axios';
import { StateButton } from '../../../../Common/fStateButton';
import LogCards from '../../../fThirdParty/Custom/LogCards';



const Index = () => {

  const [syncedWithDarwin, setSyncedWithDarwin] = useState(0);
  const [darwinError, setDarwinError] = useState({ remarks: 'No error while syncing' });
  const [loading,setLoading] = useState(false);
  const [logs,setLogs] = useState([])

  useEffect(() => {
    pluginsGetApi('plugins/custom/compass/hrms/info', (e, r) => {
      if (r) {
        setSyncedWithDarwin(r.syncedWithCompassGrphum);
        setDarwinError(r.compassGrphumError);
        let items = []
        if(r.loggedFiles){
					items=Object.entries(r.loggedFiles).map((e) => {
					  return {
						key:e[0],
						value:e[1]
					  }
					});
          setLogs(items) 
				}
      }
    });
  }, []);

 

  const syncWithDarwin = () => {
	setLoading(true);
    pluginsPostApis('plugins/custom/compass/hrms/syncWithHrms', {}, (e, r) => {
      if (r) {
		setLoading(false);
        showToast({
          type: 'success',
          message: 'Event triggered successfully!',
        });
      } else {
		setLoading(false);
        handleError(e);
      }
    });
  };
  
  return (
    <div>
      <TitleTopHeader items={[]} title="Compass HRMS Sync" des="Syncing of data with Compass HRMS box." />
      <Header title="Compass HRMS Sync" des="Syncing of data with Compass HRMS." />
      <div
        className="title-container"
        style={{
          padding: 18,
        }}
      >
        <FloatInput
          handleRef={(ref) => {}}
          type="text"
          title="Last Synced On"
          inputProps={{
            disabled: true,
            value: Moment(syncedWithDarwin).format('DD-MM-YYYY HH:MM A'),
          }}
        />
        <FloatInput
          handleRef={(ref) => {}}
          type="text"
          title="Last Error"
          inputProps={{
            disabled: true,
            value: darwinError ?  darwinError.remarks: null,
          }}
        />
        <div>
		  {
			loading ?
			<StateButton />
			:
		  
          <button onClick={syncWithDarwin} className="btn btn-success" style={{ marginTop: 12 }}>
            Sync
          </button>

		}
     </div>
    {logs.length > 0 && <LogCards logs = {logs}/>}
       
      </div>
    </div>
  );
};

export default Index;
